import Type from './Type';
export function isIVideo(node) {
    return node.type === Type.Video;
}
export default isIVideo;    //# sourceMappingURL=isIVideo.js.map
